<template>
    <div class="warpper padding-sm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input-form">
            <div class="page-title line-height">组织信息</div>
            <el-form-item ref="morglogo" label="机构LOGO" prop="morglogo" class="form-row-item flex align-center margin-tb-sm">
                <el-upload
                        class="avatar-uploader margin-left"
                        :action="`${ONLINEHOST_EMOF}home/User/imgthumb`"
                        :data="fileData"
                        :name="'image'"
                        :show-file-list="false"
                        accept="image/*"
                        :on-success="handleAvatarSuccess"
                        :disabled="readonly">
                    <div class="flex align-center">
                        <el-image class="logo" :src="ruleForm.morglogo" v-if="ruleForm.morglogo"></el-image>
                        <div class="logo up" v-else>+</div>
                        <div class="el-upload__tip margin-left" slot="tip">推荐尺寸大小120px*120px,5M以内</div>
                    </div>
                </el-upload>
            </el-form-item>

            <div class="page-title margin-tb-sm">基本信息</div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgname" label="分支机构名称" prop="morgname" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgname" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="rankId" class="input-container" label="分支机构等级" labelWidth="100px" prop="rankId">
                        <el-select v-model="ruleForm.rankId" placeholder="请选择分支机构等级">
                            <el-option
                                v-for="item in levelList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="contacts" class="input-container" label="联系人" labelWidth="100px" prop="contacts">
                        <el-input v-model="ruleForm.contacts" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgtel" class="input-container" label="联系电话" labelWidth="100px" prop="morgtel">
                        <el-input v-model="ruleForm.morgtel" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item ref="address" class="input-container" label="地址" labelWidth="100px" prop="address">
                        <el-input v-model="ruleForm.address" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgemail" label="邮箱" prop="morgemail" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgemail" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgurl" label="网址" prop="morgurl" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgurl" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-title margin-tb-sm">分支机构介绍</div>

            <el-form-item ref="morgdesc" label="分支机构介绍" labelWidth="90px" class="margin-bottom-sm" prop="morgdesc">
                <div class="input-container padding-xs">
                    <div class="morgdesc" v-show="readonly" v-html="ruleForm.morgdesc"></div>
                    <VueUditorWrap  v-model="ruleForm.morgdesc" :config="myConfig"  v-show="!readonly"></VueUditorWrap>
                </div>
            </el-form-item>
            <div class="info-container margin-bottom-sm flex-sub">
                <div class="flex align-start justify-between margin-bottom-sm">
                    <div class="page-title">积分信息</div>
                </div>
                <div class="ship-list flex flex-direction align-center">
                    <el-table
                        :data="integrals"
                        border
                        header-row-class-name="table-header"
                        style="width: 100%;border-radius: 10px">
                        <el-table-column label="序号" prop="name">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ (page - 1) * limit + scope.$index + 1 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="积分" prop="integral">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.integral }}分
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="获取时间" prop="create_time">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.create_time }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="获取途径" prop="integral_type_name">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    {{ scope.row.integral_type_name }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        :current-page.sync="page"
                        :page-size="limit"
                        :total="integral_tatal"
                        background
                        class="page-all margin-top"
                        layout="prev, pager, next, jumper"
                        @current-change="getIntegralDetail">
                    </el-pagination>
                </div>
            </div>

            <div class="flex align-center justify-center margin-tb" v-if="user.isBranch">
                <el-button type="primary" @click="submitForm('ruleForm')" class="input-form-btn"
                           :loading="loading">提交
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import VueUditorWrap from 'vue-ueditor-wrap'
    import {bdEditConfig} from "@/utils/utils"
    import rules from "@/utils/rules";
    import {getParentInfo,setParentInfo,getRankListFH} from '@/api/branch'
    // import {baseURL} from "@/config";
    import {img_url} from "@/utils/const";
    import {getIntegralDetail} from "../../../../api/member";
    import {ONLINEHOST_EMOF} from "@/config";

    export default {
        name: "info",
        data() {
            return {
                ONLINEHOST_EMOF:ONLINEHOST_EMOF,
                myConfig: bdEditConfig(),
              baseURL:img_url,
                readonly: false,
                ruleForm: {
                    morglogo: '',
                    morgname:'',
                    rankId:'',
                    contacts:'',
                    morgtel:'',
                    address:'',
                    morgemail:'',
                    morgurl:'',
                    morgdesc:'',
                },
                rules: {
                    // morglogo: [{required: true, message: "请上传机构LOGO", trigger: "change"}],
                    morgname: [
                        {required: true, message: '请输入分支机构名称', trigger: 'blur'}
                    ],
                    rankId: [{required: true, message: "请选择分支机构等级", trigger: "change"}],
                    contacts: [
                        {required: true, message: '请输入联系人', trigger: 'blur'}
                    ],
                    morgtel: rules.tel,
                    // address: [
                    //     {required: true, message: '请输入地址', trigger: 'blur'}
                    // ],
                    morgemail: [
                        // {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
                    ],
                    morgurl: [
                        rules.webUrl
                    ],
                    morgdesc: [
                        {required: true, message: '请输入分支机构介绍', trigger: 'blur'}
                    ],

                },
                loading: false,
                levelList:[],

                integrals: [],
                integral_tatal: 0,
                page: 1,
                limit: 5
            }
        },
        computed: {
            fileData() {
                return {
                    mid: this.$store.state.user.emofUserTokenSafer
                }
            },
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.$emit('setIndex', [5, 0], '组织信息')
            this.getRankList()
            this.getIntegralDetail()
            this.init()
        },
        components: {VueUditorWrap},
        methods: {
            async init() {
                let _data = await getParentInfo()
                if (_data.status === 200) {
                    this.ruleForm = {
                        morglogo: _data.data.logo,
                        morgname: _data.data.name,
                        rankId: _data.data.rank_id || '',
                        contacts: _data.data.lianxiren,
                        morgtel: _data.data.lianxidianhua,
                        address: _data.data.addresss,
                        morgemail: _data.data.email,
                        morgurl: _data.data.website,
                        morgdesc: _data.data.desc,
                    }
                }
            },
            async getIntegralDetail() {
                let _data = await getIntegralDetail(this.user.parent_id,this.user.fhid,2,this.page,this.limit)
                this.integrals = _data.data
                this.integral_tatal = _data.count
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid, validates) => {
                    if (valid) {
                        this.submitChange();
                    } else {
                        let error = Object.values(validates).shift().shift()
                        let dom = this.$refs[error.field]
                        this.$confirm(error.message, "提示", {
                            confirmButtonText: "确定",
                            showCancelButton: false,
                            type: "warning",
                        }).then(() => {
                            dom.$el.scrollIntoView({
                                block: 'center', // 当前元素显示在视图区域中间
                                behavior: 'auto' // 滚动速度
                            })
                        })
                    }
                });
            },
            async submitChange() {
                this.loading = true
                let _data = await setParentInfo(this.ruleForm.morglogo, this.ruleForm.morgname,
                    this.ruleForm.rankId, this.ruleForm.contacts, this.ruleForm.morgtel, this.ruleForm.address,
                this.ruleForm.morgemail,this.ruleForm.morgurl,this.ruleForm.morgdesc)
                this.loading = false
                if (_data.status === 200) {
                    this.$store.state.user.morgurl = this.ruleForm.morgurl
                    this.$store.state.user.logo = this.ruleForm.morglogo
                    this.$store.state.user.morgname = this.ruleForm.morgname
                    this.$store.state.user.name = this.ruleForm.morgname
                    await window.localStorage.setItem('user', JSON.stringify(this.$store.state.user))
                    await this.$store.commit('setUserInfo', this.$store.state.user)
                    window.location.reload()
                    this.$message.success('提交成功')
                }
            },
            //  获取等级列表
            async getRankList() {
                let _list = await getRankListFH(2)
                this.levelList = _list.data
            },
            handleAvatarSuccess(res) {
                if (res.status === 200) {
                    this.ruleForm.morglogo = res.data
                } else {
                    this.$message.error(res.msg)
                }
            },
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px 30px;
        .logo {
            width: 80px;
            height: 80px;
            border-radius: 80px;
            &:hover{
                border: 1px dotted #fc7802;
            }
            &.up {
                border: 1px dotted #999999;
                line-height: 60px;
                text-align: center;
            }
        }
        .el-select {
            width: 100%;
        }
        .morgdesc{
            border-radius: 10px;
            border: solid 1px #dae0e6;
            padding: 12px;
        }
        .input-form-btn {
            width: 200px;
            height: 40px;
            line-height: 40px;
            border-radius: 40px;
            font-size: 16px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            color: #ffffff;
            margin-top: 20px;
            padding: 0;
            &.white {
                background: #ffffff none;
                color: #ff9600;
            }
        }
    }
    .table-name {
        font-size: 16px;
        color: #0a2240;
        text-align: center;
    }
</style>
